import React, { FC, ReactElement } from 'react'
import styles from './ProfileSocialLink.module.css'
import classnames from 'classnames'

const ProfileSocialLink: FC<{
	href: string
	icon: React.FC<{
		className?: string
	}>
	ariaLabel?: string
	iconClassName?: string
	title?: string
}> = (props): ReactElement => {
	return (
		<a
			aria-label={props.ariaLabel}
			className={styles.root}
			href={props.href}
			rel="noopener noreferrer"
			target="_blank"
			title={props.title}
		>
			<props.icon
				className={classnames({ [(props.iconClassName as any)]: !!props.iconClassName }, styles.icon)}
			/>
		</a>
	)
}

export default ProfileSocialLink
